export const getTabs = (can: any) => [
  {
    id: "1",
    name: "Главная",
    url: "/",
  },
  {
    id: "2",
    name: "Справочники",
    items: [
      {
        id: "2_1",
        name: "Отступы",
        url: "/gap",
      },
      {
        id: "2_2",
        name: "Смещения",
        url: "/displacement",
      },
      {
        id: "2_3",
        name: "Контейнеры",
        url: "/container",
      },
      {
        id: "2_4",
        name: "Динамические справочники",
        url: "/dCatalogue",
      },
      {
        id: "2_5",
        name: "Свойства пакета",
        url: "/feature",
      },
      {
        id: "2_6",
        name: "Типы пакетов по объему",
        url: "/packageVolumeType",
      },
      {
        id: "2_7",
        name: "Примечания к заказам",
        url: "/orderComment",
      },
    ],
  },
  {
    id: "3",
    name: "Журналы",
    items: [
      {
        id: "3_1",
        name: "Планы",
        url: "/plans",
      },
    ],
  },
  {
    id: "4",
    name: "Отчеты",
    items: [
      {
        id: "4_1",
        name: "Отчет о погрузке",
        url: "/loadingReport",
      },
      {
        id: "4_2",
        name: "Отчет по контейнерам",
        url: "/containerReport",
      },
      {
        id: "4_3",
        name: "Отчет по заказам",
        url: "/orderReport",
      },
    ],
  },
  {
    id: "5",
    name: "Администрирование",
    visible: can("view", "Administration"),
    items: [
      {
        id: "5_1",
        name: "Пользователи",
        url: "/users",
      },
      {
        id: "5_2",
        name: "Роли",
        url: "/roles",
      },
      {
        id: "5_3",
        name: "Импорт данных",
        url: "/import",
      },
      {
        id: "5_4",
        name: "Действия пользователей",
        url: "/logging",
      },
      {
        id: "5_5",
        name: "Очистка данных",
        url: "/cleanup",
      },
    ],
  },
  {
    id: "6",
    name: "Настройки",
    visible: can("view", "Settings"),
    url: "/settings",
  },
];

export const showFirstSubmenuModes = {
  name: "onHover",
  delay: { show: 0, hide: 100 },
};
